/**
 * A class to hold all data about a task.
 */
export class JsTask {
  constructor (id, gTask) {
    // The local identifier for this task. This is different from the gTask ID
    // because it needs to be available and unique even if the task has just
    // been added and not yet committed to the server.
    this.id = id

    // The Google Task resource. Must not be null.
    // https://developers.google.com/tasks/v1/reference/tasks
    this.gTask = gTask

    // A list of JsTask objects that are children of this JsTask.
    this.subtasks = []

    // True if this task is the root of the list, which is not actually
    // displayed.
    this.isRoot = false

    // Set to true if the task is being deleted.
    this.deleted = false
  }

  sortSubtasks() {
    this.subtasks.sort((a, b) => {
      if (a.gTask.position < b.gTask.position) {
        return -1
      }
      if (a.gTask.position > b.gTask.position) {
        return 1
      }
      return 0
    })
    for (let subtask of this.subtasks) {
      subtask.sortSubtasks()
    }
  }
}

/**
 * Returns an object representing the minimal amount of a gTask necessary.
 */
export function newGTask () {
  return {
    id: '',
    title: '',
    status: 'needsAction'
  }
}

/**
 * Determines whether left and right are gTasks that are equal as far as we
 * care (so things like id and title, but not timestamps).
 *
 * Returns { success: bool, message: string } where message is an error message.
 */
export function equivGTasks (left, right) {
  let importantFields = ['id', 'etag', 'title', 'parent', 'position', 'status', 'due', 'completed']
  let success = true
  let message = ''
  for (let field of importantFields) {
    if (left[field] !== right[field]) {
      success = false
      message += 'gTask field \'' + field + '\' does not match:\n' + left[field] + '\n' + right[field] + '\n\n'
    }
  }
  return {
    'success': success,
    'message': message
  }
}
